export default "__VITE_ASSET__DfdHyr7z__"